import React, { createContext, useContext, useEffect, useState } from "react";
import { useLazyGetUserInfoQuery } from "store/slices/apis/authSlice";
import { useLazyGetProjectPermissionQuery } from "store/slices/apis/projectPermissionSlice";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    // const { projectId } = useParams();
    const [authenticated, setAuthenticated] = useState(false);
    const [user, setUser] = useState(null); // user data from API
    const [triggerUserInfo, { data, isSuccess, isError, isLoading }] = useLazyGetUserInfoQuery();
    const [projectPermissionFun, projectPermissionRes] = useLazyGetProjectPermissionQuery();

    const [token, setToken] = useState(() => localStorage.getItem("token"));

    useEffect(() => {
        if (token) {
            triggerUserInfo();
        }
    }, [token]);

    useEffect(() => {
        const storedToken = localStorage.getItem("token");
        if (storedToken) {
            setToken(storedToken);
        }
    }, []);

    // useEffect(() => {
    //     console.log(projectId);

    //     if (user?.permission?.length == 0 && projectId !== undefined) {
    //         projectPermissionFun({ projectId });
    //     }
    // }, [user, projectId]);

    useEffect(() => {
        if (isSuccess && data) {
            setUser(data?.data);
            setAuthenticated(true)
        }
    }, [data, isSuccess, isError]);

    // useEffect(() => {
    //     if (isSuccess && data) {
    //         setUser(data);
    //         setAuthenticated(true)
    //     }
    // }, [data, isSuccess, isError]);

    const getuserInfo = (newToken) => {

        localStorage.setItem("token", newToken);
        triggerUserInfo();
        setToken(newToken);
    };

    const getProjectPermissionInfo = async (projectId) => {
        await projectPermissionFun(projectId);
    };

    useEffect(() => {
        if (projectPermissionRes?.isSuccess) {

            if (projectPermissionRes?.data?.status?.toLowerCase() == 'success') {
                // console.log(data?.data);

                // console.log(projectPermissionRes?.data?.data?.modules);

                setUser({
                    ...data?.data,
                    permission: projectPermissionRes?.data?.data?.modules
                });
            }
        }
    }, [projectPermissionRes]);


    const logout = () => {
        localStorage.removeItem("token");
        setUser(null);
        setAuthenticated(false);
        setToken(null);
    };

    return (
        <AuthContext.Provider value={{ user, logout, getuserInfo, setUser, getProjectPermissionInfo, authenticated, setAuthenticated, isLoading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);